import { APICore } from './apiCore'

const api = new APICore()

function getExperiences (params) {
  const baseUrl = '/experiences'
  return api.get(baseUrl, params)
}

function getExperience (id) {
  const baseUrl = `/experiences/${id}`
  return api.get(baseUrl, {})
}

function addExperience (params) {
  const baseUrl = '/experiences'
  return api.createWithFile(baseUrl, params)
}

function updateExperience (params) {
  const baseUrl = '/experiences'
  return api.updateWithFile(baseUrl, params)
}

function deleteExperience (params) {
  const baseUrl = '/experiences'
  return api.delete(baseUrl, params)
}

export { getExperiences, getExperience, addExperience, updateExperience, deleteExperience }
